export default __webpack_public_path__ + "static/Oman-cd8c418e176047cbd9f8a03a7fc4c6a8.png";